import { FC } from 'react';

import { dom } from 'app/utils';
import { InputTextarea as Component, InputTextareaProps as Props } from '../external';
import { IInput } from './types';

export interface ITextarea extends IInput<string> {
  autoResize?: boolean;
}

export const TextArea: FC<ITextarea> = ({ id, className, style, disabled, name, value, placeholder, tooltip, autoFocus, readOnly, invalid, autoResize, onBlur, onChange, onFocus }: ITextarea) => {
  const props: Props = { id, style, disabled, name, placeholder, tooltip, autoFocus, readOnly, invalid, autoResize, onBlur, onChange, onFocus,
    className: dom.className('i-component', 'i-input', 'i-textarea', { 'i-invalid': invalid }, className),
    value: (value ?? ''),
  };

  return (
    <Component { ...props } />
  );
}
